import { Dropdown, Button, Menu } from 'antd';
import React from 'react';
import ulbActionList from '../../../Assets/json/ulb-action-list.json';
import rdoActionList from '../../../Assets/json/ro-action-list.json';
import stateActionList from '../../../Assets/json/state-action-list.json';
import adminActionList from '../../../Assets/json/admin-action-list.json';


const menuDropdown = (props) => {
    const { label, role, handleDropDownClick, currentStatus } = props;
    const menuJson = () => {
        if (role === "ulb") {
            return ulbActionList;
        } else if (role === "rdo") {
            return rdoActionList;
        } else if (role === "state") {
            return stateActionList;
        }
        else if (role === "all") {
            return adminActionList;
        }
    }
    const itemsList = menuJson()?.filter(item => {
        if (item.key !== currentStatus)
            return (
                {
                    key: item?.key,
                    label: <div>{item.label}</div>,
                });
    })
    const menu =
        <Menu
            onClick={handleDropDownClick}
            items={itemsList} />

    return (
        <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
            <Button className="dropdown-container">{label}</Button>
        </Dropdown>
    )
}

export default menuDropdown;